import PlannedProjectCreate from '@containers/project/PlannedProjectCreate';
import { useEffect } from 'react';

const PlannedProjectCreatePage = () => {
  useEffect(() => {}, []);

  return <PlannedProjectCreate />;
};

export default PlannedProjectCreatePage;
